import { render, staticRenderFns } from "./CreateAssistant.first.step.vue?vue&type=template&id=616e6edc&scoped=true&"
import script from "./CreateAssistant.first.step.vue?vue&type=script&lang=js&"
export * from "./CreateAssistant.first.step.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssistant.first.step.vue?vue&type=style&index=0&id=616e6edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e6edc",
  null
  
)

export default component.exports